import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import i18n from '../../i18n';
import { RootState } from '../reducers/rootReducer';
import { printEPTourLabel } from '../actions/activePickTour.actions';
import { createToast } from '../actions/toasts.actions';
import { setLoading } from '../actions/loading.actions';

import {
  BFF_PICK_TOURS,
  BFF_V1,
  BFF_REPRINT_LABEL,
  SAGA_REPRINT_EP_LABEL,
  PRINT_EP_LABEL_ERROR,
  MOBILE_PRINTER_NUMBER,
  PICKING_APIGEE_BASE_PATH,
} from '../../constants';

import { APIError, ConfigAuthValues } from '../../types';

import { callAPI } from '../../utils';

import { handleApiErrors } from './utils';
import { APIPickTourListItem, CompletedEPTourContent } from './types'; // use RePrintEPTourResponse once BE api is updated after store changes are done

const callRePrintLabel = (configAuthValues: ConfigAuthValues, data: (CompletedEPTourContent | APIPickTourListItem)[]) => {
  const mobilePrinterNumber = localStorage.getItem(MOBILE_PRINTER_NUMBER) || '';
  return callAPI({
    method: 'POST',
    url: `${configAuthValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}${BFF_REPRINT_LABEL}?printerName=${mobilePrinterNumber}`,
    data,
  });
}
  

export function* runRePrintEPTourSaga(action: ReturnType<typeof printEPTourLabel>): Generator<any, void, any> {
  const configAuthValues = yield select((state: RootState) => state.config.authValues);
  yield put(setLoading({ sagaName: SAGA_REPRINT_EP_LABEL, isLoading: true }));

  try {
    const response = yield call(callRePrintLabel, configAuthValues, action.payload.data);
    if (response.status >= 200 && response.status < 300) {
      yield put(createToast({ type: 'success', message: i18n.t('RE_PRINT_EP_LABEL_SUCCESS') }));
    } else {
      const { errors = [] } = response.data || {};
      const printError: APIError[] = [{ id: '', code: PRINT_EP_LABEL_ERROR, detail: JSON.stringify(errors) }];
      yield handleApiErrors(printError);
    }
  } catch (error) {
    const printError: APIError[] = [{ id: '', code: PRINT_EP_LABEL_ERROR, detail: JSON.stringify(error) }];
    yield handleApiErrors(printError);
  }
  yield put(setLoading({ sagaName: SAGA_REPRINT_EP_LABEL, isLoading: false }));
}

export default function* watchRePrintEPTour() {
  yield takeEvery(getType(printEPTourLabel), runRePrintEPTourSaga);
}
